export const listTypeForce = [
    'MASKCC_3D',
    'MASKCCNUT_3D',
    'MASK_3D',
    'MASK_HYPER_3D',
    'MASK_SQUARE_3D',
    'MASK_PS_3D',
    'MASK_PQ_3D',
    'MASKCC_V2_3D',
    'MASK_NEP_3D',
    'MASK_NEP_NUT_3D',
    'MASK_NUT_3D',
    'STICKER',
    'UV_LED',
    'UV_LED_MICA',
    'ENGRAVED_LED',
    'ORNAMENT_3D',
    'CUT_ORNAMENT_3D',
    'ENGRAVED_ORNAMENT_3D',
    '1_MDF_ORNAMENT_3D',
    '2_MDF_ORNAMENT_3D',
    'MDF_CUSTOM_ORNAMENT_3D',
    'CUSTOM_ORNAMENT_3D',
    'CUSTOM_ORNAMENT_V2_3D',
    'CUSTOM_CAR_ORNAMENT',
    'PLASTIC_CAR_ORNAMENT',
    '1_PLASTIC_CAR_ORNAMENT',
    '1_WHITE_PLASTIC_ORNAMENT',
    '1_WHITE_PLASTIC_ORNAMENT_DZT',
    '1_WHITE_PLASTIC_CAR_ORNAMENT',
    'PLASTIC_WINDOW_ORNAMENT',
    '1L_WOOD_ORNAMENT',
    '2L_WOOD_ORNAMENT',
    'WOOD_ACRYLIC_ORNAMENT',
    'WOOD_KEYCHAIN_3D',
    'MICA_KEYCHAIN_V2_3D',
    'MICA_KEYCHAIN_3D',
    'PET_KEYCHAIN_3D',
    'MICA_PIN',
    'BRAND_KIT',
    'MICA_ORNAMENT_UID',
    '1L_WOOD_ORNAMENT_UID',
    '1_ALUMINIUM_ORNAMENT',
    '2_ALUMINIUM_ORNAMENT',
    '1_CERAMIC_ORNAMENT',
    '1_CERAMIC_ORNAMENT_DZT',
    '2_CERAMIC_ORNAMENT',
    'GLASS_ORNAMENT',
    'ORNAMENT_IN3',
    'CUSTOM_ORNAMENT_V2_IN3',
    'SHAKER_ORNAMENT',
    '1_ALUMINIUM_ORNAMENT_DZT',
    'WOOD_ACRYLIC_ORNAMENT_DZT',
    'CUS_ORNAMENT_V2_REDBOX',
    '2_CERAMIC_ORNAMENT_PAW',
    '1L_WOOD_ORNAMENT_PAW',
    '2L_WOOD_ORNAMENT_PAW',
    '1_WHITE_ORNAMENT_PAW',
    '2_ALU_ORNAMENT_PAW',
    'HEART_KEYCHAIN_SET',
    'MASKCC_01',
    'MASK_01',
    'MASK_SQUARE_01',
    'MASKCC_V2_01',
    'UV_LED_0103MT',
    'UV_LED_0103MT',
    'CUT_ORN_0203CU',
    'CUT_ORN_0203CU',
    'CUSTOM_ORN_0103MTM',
    'CUSTOM_ORN_0103MTM',
    '1W_ORN_0103MT',
    'CUSTOM_ORN_0103MTM',
    '1W_ORN_0103MT',
    '1W_ORN_0103MT',
    'CUSTOM_ORN_0103MTM',
    '1L_ORN_0203TM',
    '2L_ORN_0203TM',
    '2L_REG_ORN_12MT',
    '2L_SUN_ORN_DZT_12MM',
    '1L_KEY_0103MT',
    '2L_KEY_0102MT',
    'CUSTOM_ORN_0103MTM',
    '1L_ORN_0203TM',
    '1S_ALU_ORN_0500D7TM',
    '2S_ALU_ORN_0500D7TM',
    '1S_CER_ORN_0303TM',
    '1S_CER_ORN_0303TM',
    '2S_CER_ORN_0303TM',
    'GLASS_ORN_0406MT',
    'CUSTOM_ORN_0103IN3',
    'CUSTOM_ORN_0103IN3',
    '3L_SHAKER_0102MTM',
    '1S_ALU_ORN_0500D7TM',
    '2L_REG_ORN_12MT',
    '2L_SUN_ORN_12MM',
    'CUSTOM_ORN_0103MTM',
    '2S_CER_ORN_0303TM',
    '1L_ORN_0203TM',
    '2L_ORN_0203TM',
    '1W_ORN_0103MT',
    '2S_ALU_ORN_0500D7TM',
    '2P_HEART_KEY_0502KH',
    '2S_ORN_0203TM',
    'GIFTBOX_0700NO',
    'UV_LED_BASE_0200',
    'WOOD_HANGER_48',
    'GIFTCARD_1800NO',
    'BOX_0700NO',
]
